<template>
    <div>
        <v-btn text @click="helpClicked" color="grey lighten-2">
            <v-icon class="mr-1">mdi-information-outline</v-icon>
            HELP
        </v-btn>

        <help v-if="helpDialogModel"
              v-model="helpDialogModel"
              :identifier="help"
        ></help>
    </div>
</template>

<script>

import Help from '../../modules/Help/components/index';

export default {

    name: "HelpIcon",

    components: {
        Help
    },

    props: {
        help: {
            required: true,
            type: String,
        }
    },

    data() {
        return {
            helpDialogModel: false,
        }
    },

    methods: {
        helpClicked() {
            this.helpDialogModel = true;
        },
    }
}
</script>
